import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=bb7ce584&scoped=true"
import script from "./ImportUpload.vue?vue&type=script&lang=js"
export * from "./ImportUpload.vue?vue&type=script&lang=js"
import style0 from "./ImportUpload.vue?vue&type=style&index=0&id=bb7ce584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7ce584",
  null
  
)

export default component.exports